// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-NavigationBar-absolute-center","navigation":"onfido-sdk-ui-NavigationBar-navigation","fullScreenNav":"onfido-sdk-ui-NavigationBar-fullScreenNav","back":"onfido-sdk-ui-NavigationBar-back","iconBack":"onfido-sdk-ui-NavigationBar-iconBack","disabled":"onfido-sdk-ui-NavigationBar-disabled","label":"onfido-sdk-ui-NavigationBar-label","backHoverDesktop":"onfido-sdk-ui-NavigationBar-backHoverDesktop"};


//////////////////
// WEBPACK FOOTER
// ./components/NavigationBar/style.css
// module id = 378
// module chunks = 1